var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-preview"},[(_vm.isPdf)?[_c('embed',{staticClass:"file-preview__embed",attrs:{"src":_vm.fileData.url + '#toolbar=0&navpanes=0'}})]:(_vm.isImage)?[_c('img',{staticClass:"file-preview__image",attrs:{"src":_vm.fileData.url}})]:[_c('p',{staticClass:"file-preview__error"},[_vm._v("This file can not be displayed.")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }